
export const darkTheme = {
        bg: '#1C1C27',
        bgLight: '#1C1C27',
        primary: '#55a3bb',
        text_primary: '#f2f3f4',
        text_secondary: '#b1b2b3',
        card: '#171721',
        card_light: '#191924',
        button: '#55a3bb',
        white: '#ffffff',
        black: '#000000',
};

// export const darkTheme = {
//         bg: '#ffffff',
//         bgLight: '#f1f1f1',
//         primary: '#000000',
//         text_primary: '#000000',
//         text_secondary: '#000000',
//         card: '#ffffff',
//         card_light: '#ffffff',
//         button: '#ffffff',
//         white: '#ffffff',
//         black: '#000000',
// };

export const lightTheme = {
    bg: '#ffffff',
    bgLight: '#f0f0f0',
    primary: '#55a3bb',
    text_primary: '#111111',
    text_secondary: '#48494a',
    card: '#ffffff',
    card_light: '#ffffff',
    button: '#55a3bb',
    white: '#ffffff',
    black: '#000000',
};
